<div>
  <ef-navbar></ef-navbar>
  <router-outlet></router-outlet>
  <ef-toast-wrapper></ef-toast-wrapper>
</div>
